const EmployeeListActionTypes = {
	EMPLOYEELIST_START: 'EMPLOYEELIST_start',
	EMPLOYEELIST_SUCCESS: 'EMPLOYEELIST_success',
	EMPLOYEELIST_FAILURE: 'EMPLOYEELIST_failure',
	EMPLOYEELIST_RESPONSE_CHANGED: 'EMPLOYEELIST_response_changed',
	EMPLOYEELIST_RESPONSE_REST_START: 'EMPLOYEELIST_response_rest_start',
	EMPLOYEELIST_RESPONSE_REST_SUCCESS: 'EMPLOYEELIST_RESPONSE_REST_SUCCESS',
	EMPLOYEELIST_RESPONSE_REST_FAILURE: 'EMPLOYEELIST_RESPONSE_REST_FAILURE',
	GET_ALL_EMPLOYEE_LIST_START: 'GET_ALL_EMPLOYEE_LIST_START',
	GET_ALL_EMPLOYEE_LIST_SUCCESS: 'GET_ALL_EMPLOYEE_LIST_SUCCESS',
	GET_ALL_EMPLOYEE_LIST_FAILURE: 'GET_ALL_EMPLOYEE_LIST_FAILURE',
	GET_ALL_EMPLOYEE_LIST_RESPONSE_CHANGED: 'GET_ALL_EMPLOYEE_LIST_RESPONSE_CHANGED',
	GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_START: 'GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_START',
	GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_SUCCESS: 'GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_SUCCESS',
	GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_FAILURE: 'GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_FAILURE',
	GET_ALL_EMPLOYEE_LIST_KEY: 'GetAllEmployeeDetailsFromWeb',
	GET_EMPLOYEE_BY_ID_START: 'GET_EMPLOYEE_BY_ID_START',
	GET_EMPLOYEE_BY_ID_SUCCESS: 'GET_EMPLOYEE_BY_ID_SUCCESS',
	GET_EMPLOYEE_BY_ID_FAILURE: 'GET_EMPLOYEE_BY_ID_FAILURE',
	GET_EMPLOYEE_BY_ID_RESPONSE_CHANGED: 'GET_EMPLOYEE_BY_ID_RESPONSE_CHANGED',
	GET_EMPLOYEE_BY_ID_RESPONSE_REST_START: 'GET_EMPLOYEE_BY_ID_RESPONSE_REST_START',
	GET_EMPLOYEE_BY_ID_RESPONSE_REST_SUCCESS: 'GET_EMPLOYEE_BY_ID_RESPONSE_REST_SUCCESS',
	GET_EMPLOYEE_BY_ID_RESPONSE_REST_FAILURE: 'GET_EMPLOYEE_BY_ID_RESPONSE_REST_FAILURE',
	UPDATE_EMPLOYEE_START: 'UPDATE_EMPLOYEE_START',
	UPDATE_EMPLOYEE_SUCCESS: 'UPDATE_EMPLOYEE_SUCCESS',
	UPDATE_EMPLOYEE_FAILURE: 'UPDATE_EMPLOYEE_FAILURE',
	UPDATE_EMPLOYEE_RESPONSE_REST_START: 'UPDATE_EMPLOYEE_RESPONSE_REST_START',
};

export default EmployeeListActionTypes;
